import { CircularProgress } from "@mui/material";

export default function Loading({ open }: { open: boolean }) {
  if (!open) {
    return null;
  }

  return (
    <div className="absolute inset-0 flex items-center justify-center z-40">
      <CircularProgress />
    </div>
  );
}
